import { createContext, useContext, useState, useEffect } from "react";

const ThemeContext = createContext(null);

// Available visual themes
export const VISUAL_THEMES = {
  netset: {
    id: 'netset',
    name: 'Netset Original',
    description: 'Clean and professional',
  },
  cyber: {
    id: 'cyber',
    name: 'Cyber Tech',
    description: 'Futuristic neon style',
  },
  matrix: {
    id: 'matrix',
    name: 'Matrix',
    description: 'Digital rain terminal',
  },
};

export const ThemeProvider = ({ children }) => {
  // Light/Dark mode
  const [theme, setTheme] = useState(() => {
    const stored = localStorage.getItem("theme");
    if (stored) return stored;
    if (window.matchMedia("(prefers-color-scheme: dark)").matches) {
      return "dark";
    }
    return "light";
  });

  // Visual theme (netset, cyber, etc.)
  const [visualTheme, setVisualTheme] = useState(() => {
    return localStorage.getItem("visualTheme") || "netset";
  });

  useEffect(() => {
    const root = window.document.documentElement;
    
    // Handle light/dark mode
    root.classList.remove("light", "dark");
    root.classList.add(theme);
    localStorage.setItem("theme", theme);
    
    // Handle visual theme
    root.classList.remove("theme-netset", "theme-cyber", "theme-matrix");
    root.classList.add(`theme-${visualTheme}`);
    localStorage.setItem("visualTheme", visualTheme);
  }, [theme, visualTheme]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === "dark" ? "light" : "dark"));
  };

  return (
    <ThemeContext.Provider value={{ 
      theme, 
      setTheme, 
      toggleTheme, 
      visualTheme, 
      setVisualTheme,
      visualThemes: VISUAL_THEMES 
    }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
};
